// src/components/CompatibilityComparator.jsx
import React, { useState } from 'react';
import zodiacData from '../data/zodiac-data.json';
import { getCompatibility } from '../utils/zodiacUtils';

const LEVEL_CLASS = {
  Alta: 'zodiac-badge--alta',
  Media: 'zodiac-badge--media',
  Desafiante: 'zodiac-badge--desafiante',
};

const CompatibilityComparator = () => {
  const signNames = zodiacData.signs.map((s) => s.name);
  const [signA, setSignA] = useState(signNames[0]);
  const [signB, setSignB] = useState(signNames[1]);

  const findSign = (name) => zodiacData.signs.find((s) => s.name === name);
  const symbolA = findSign(signA)?.symbol;
  const symbolB = findSign(signB)?.symbol;

  const result = signA === signB
    ? { level: 'Alta', text: `Dos personas de ${signA} comparten la misma esencia: se entienden con una facilidad natural, aunque también pueden potenciar entre sí los mismos defectos del signo.` }
    : getCompatibility(signA, signB);

  return (
    <div className="zodiac-tool-card">
      <h3 className="zodiac-section-title font-cinzel">Comparar Compatibilidad</h3>
      <p className="zodiac-tool-desc">Elegí dos signos y descubrí cómo es la dinámica entre ambos.</p>

      <div className="zodiac-compare-selectors">
        <select className="guide-search-input zodiac-select" value={signA} onChange={(e) => setSignA(e.target.value)}>
          {signNames.map((name) => <option key={name} value={name}>{name}</option>)}
        </select>
        <span className="zodiac-compare-vs">✦</span>
        <select className="guide-search-input zodiac-select" value={signB} onChange={(e) => setSignB(e.target.value)}>
          {signNames.map((name) => <option key={name} value={name}>{name}</option>)}
        </select>
      </div>

      {result && (
        <div className="zodiac-compat-row zodiac-compare-result">
          <div className="zodiac-compat-row-header">
            <span className="zodiac-compat-sign">{symbolA} {signA} · {symbolB} {signB}</span>
            <span className={`zodiac-badge ${LEVEL_CLASS[result.level] || ''}`}>{result.level}</span>
          </div>
          <p className="zodiac-compat-text">{result.text}</p>
        </div>
      )}
    </div>
  );
};

export default CompatibilityComparator;
